<template>
  <v-banner v-if="auth.impersonating" color="warning" single-line sticky>
    You are viewing as another user.
    <template #actions>
      <v-btn variant="text" size="small" @click="stop">Stop impersonating</v-btn>
    </template>
  </v-banner>
</template>

<script setup>
import { useAuthStore } from "@/stores/auth";
import { stopImpersonate } from "@/api/admin";

const auth = useAuthStore();

async function stop() {
  try {
    const res = await stopImpersonate();
    window.location.href = res.returnUrl || "/";
  } catch (e) {
    console.error(e);
  }
}
</script>
